import {GET_SUPPLIER_POS, 
        GET_SUPPLIER_POS_ERROR,
        PO_PURCHACE_ORDER_LIST,
        PO_PURCHACE_ORDER_LIST_ERROR,
        REQUEST_PO_PURCHACE_ACTION,
        REQUEST_PO_PURCHACE_ACTION_ERROR,
        PO_PURCHACE_ORDER_LIST_FOR_VENDOR,
        PO_PURCHACE_ORDER_LIST_FOR_VENDOR_ERROR,
        CHANGE_SUPPLIER_DOCUMENT_STATUS,
        CHANGE_SUPPLIER_DOCUMENT_STATUS_ERROR
    } from '../type'
import axios from 'axios';
import env from '../../ENV';
import swal from '@sweetalert/with-react';
import AxiosHandler from '../../Classes/AxiosHandler';

import AuthHandler from '../../Classes/AuthHandler';
let ROOT_URL = env.BACKEND_URL;

AuthHandler.getUserPayLoad()

export const getSupplierPOs = (id, searchTerm, poId) => async dispatch => {
    try{
        var authUser = AuthHandler.getUserPayLoad()
        const res = await axios.post(`${ROOT_URL}vendor/${id}/po/${poId ? poId : 0}`,{email:authUser.email, SearchTerm: searchTerm})
        dispatch( {
            type: GET_SUPPLIER_POS,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_SUPPLIER_POS_ERROR,
            payload: console.log(e),
        })
    }

}

export const getPOPurchaseOrders = () => async dispatch => {
    try{
        const res = await AxiosHandler.post(`${ROOT_URL}po/list-all`,{pageNo:1})

        //for vendor call
        //const res = await axios.post(`${ROOT_URL}po/search`,{vendorId:1})
        //
        dispatch( {
            type: PO_PURCHACE_ORDER_LIST,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: PO_PURCHACE_ORDER_LIST_ERROR,
            payload: console.log(e),
        })
    }

}

export const requestPoAcceptanceAction = (input) => async dispatch => {
    try{
        const res = await axios.post(`${ROOT_URL}po/request-po-acceptance-action`,input)
        swal(res.data.message,{icon:"success"})
        dispatch( {
            type: REQUEST_PO_PURCHACE_ACTION,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: REQUEST_PO_PURCHACE_ACTION_ERROR,
            payload: console.log(e),
        })
    }

}

export const getPOPurchaseOrdersForVendor = () => async dispatch => {
    try{
        

        //for vendor call
        const res = await axios.post(`${ROOT_URL}po/search`,{vendorId:1})
        //
        dispatch( {
            type: PO_PURCHACE_ORDER_LIST_FOR_VENDOR,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: PO_PURCHACE_ORDER_LIST_FOR_VENDOR_ERROR,
            payload: console.log(e),
        })
    }

}

export const postChangeSupplierDocumentStatus = (input) => async dispatch => {
    try{
        

        //for vendor call
        const res = await axios.post(`${ROOT_URL}po/change-supplier-doc-status`,{vendorId:1})
        //
        dispatch( {
            type: CHANGE_SUPPLIER_DOCUMENT_STATUS,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: CHANGE_SUPPLIER_DOCUMENT_STATUS_ERROR,
            payload: console.log(e),
        })
    }

}

